import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { WxLaunchHack } from 'ThreeTerminal_mobile';
import Bar from './bar';
import Info from './info';

class Banner extends React.PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        // content: PropTypes.object,
        data: PropTypes.object,
        wxLaunchHackData: PropTypes.object,
        shareConfig: PropTypes.object
    };

    // 开启沉浸式全屏 隐藏app顶部导航栏
    // 安卓开启沉浸式全需要在url上拼参数：isFull=1 隐藏端内导航栏；immersion=true 撑出时间栏，全屏显示显示
    fullScreen = () => {
        if (window.grounds?.setMultiToolBarHidden && window.grounds?.maximization) {
            window.grounds.setMultiToolBarHidden(true);
            // 开启沉浸式全屏 安卓和IOS都需要执行：
            // 需要注意：当前webview开启沉浸式全屏后，若在当前页又拉起一个webview, 如果当前页需要显示导航栏就需要设置isFull=0;
            window.grounds.maximization();
        }
    };

    componentDidMount() {
        this.fullScreen();
    }

    componentDidUpdate(prevProps) {
        const {
            loading,
            data: { bidenNum, trumpNum },
        } = this.props;

        /* eslint-disable no-undef */
        if (!loading && loading !== prevProps.loading) {
            TweenLite.fromTo(
                '#left',
                0.1,
                { left: '-750px' },
                {
                    left: 0,
                },
            );

            TweenLite.fromTo(
                '#right',
                0.1,
                { right: '-750px' },
                {
                    right: 0.5,
                },
            );
        }

        if (
            (bidenNum !== prevProps.data.bidenNum && bidenNum >= 270) ||
            (trumpNum !== prevProps.data.trumpNum && trumpNum >= 270)
        ) {
            TweenLite.fromTo(
                '#left',
                0.1,
                { left: '-750px' },
                {
                    left: 0,
                },
            );

            TweenLite.fromTo(
                '#right',
                0.1,
                { right: '-750px' },
                {
                    right: 0,
                },
            );
        }

        if ((bidenNum < 270 && prevProps.data.bidenNum >= 270) || (trumpNum < 270 && prevProps.data.trumpNum >= 270)) {
            TweenLite.fromTo(
                '#left',
                0.1,
                { left: '-750px' },
                {
                    left: 0,
                },
            );

            TweenLite.fromTo(
                '#right',
                0.1,
                { right: '-750px' },
                {
                    right: 0.5,
                },
            );
        }
        /* eslint-enable no-undef */
    }

    goClose = () => {
        window.grounds.close();
    }

    goShare = () => {
        const { shareConfig } = this.props;

        window.grounds.openShare(
            shareConfig.shareurl,
            shareConfig.title,
            shareConfig.desc,
            shareConfig.thumb,
            '',
        );
    }

    goMoreContent = () => {
        const {
            wxLaunchHackData
        } = this.props;

        const url = wxLaunchHackData?.callAppConfig?.pid || '';

        if (window.grounds && url) {
            window.grounds.dispatch('web', url);
        }

    }

    render() {
        const {
            loading,
            data,
            data: { bidenNum, trumpNum, status },
            wxLaunchHackData
        } = this.props;

        let titleName = 'default_title';

        if (status === '已结束') {
            if (bidenNum >= 270) {
                titleName = 'biden_title';
            }

            if (trumpNum >= 270) {
                titleName = 'trump_title';
            }
        }

        return (
            <div className={styles.banner_box}>
                <div className={`${styles.banner} ${window.grounds ? styles.clientBanner : ''}`}>
                    {window.grounds && <div className={styles.titleBar}>
                        <div className={styles.titleBarBack} onClick={this.goClose} />
                        <div className={styles.titleBarText}>2024美国大选</div>
                        <div className={styles.titleBarShare} onClick={this.goShare} />
                    </div>}
                    <span className={bidenNum >= 270 && status === '已结束' ? styles.biden_win : styles.trump_win } />
                    <div className={styles.title_box}>
                        <div className={styles.more_box}>
                            <span className={styles.logo} />
                            <span className={styles.more} onClick={this.goMoreContent} >
                                <span>更多报道</span>
                                <span />
                                {!window?.grounds && <WxLaunchHack content={wxLaunchHackData} />}
                            </span>
                        </div>
                        <div className={styles.br} />
                        <div className={styles[titleName]} />
                    </div>
                    {status === '已结束' ? <Fragment>
                        {bidenNum >= 270 && (
                            <Fragment>
                                <div id="left" className={styles.left_empty}>
                                    <div id="trump" />
                                </div>
                                <div id="right" className={styles.right_win}>
                                    <div className={styles.biden_win_icon} />
                                    <div id="biden" />
                                </div>
                            </Fragment>
                        )}
                        {trumpNum >= 270 && (
                            <Fragment>
                                <div id="left" className={styles.left_win}>
                                    <div className={styles.trump_win_icon} />
                                    <div id="trump" />
                                </div>
                                <div id="right" className={styles.right_empty}>
                                    <div id="biden" />
                                </div>
                            </Fragment>
                        )}
                    </Fragment> :
                    <Fragment>
                        <div id="left" className={styles.left}>
                            <div id="trump" />
                        </div>
                        <div id="right" className={styles.right}>
                            <div id="biden" />
                        </div>
                    </Fragment>}
                    <Bar loading={loading} data={data} />
                </div>
                <Info loading={loading} data={data} />
            </div>
        );
    }
}

export default errorBoundary(Banner);
